import React, { useState } from 'react';
import icon from './../images/plus-line.svg';
import backIcon from '../images/close-line.svg';
import { useTranslation } from '../i18n';
import './InstallPWA.css';
import { analytics } from '../firebaseConfig';
import { logEvent } from 'firebase/analytics';

const InstallPWA = () => {
  const { t } = useTranslation();

  const [modalIsOpen, setIsOpen] = useState(false);
  function openModal() {
    setIsOpen(true);
    logEvent(analytics, 'account_settings_pwa_install');
  }
  function closeModal() {
    setIsOpen(false);
  }

  return [
    <div className="row-item" key="installPWA">
      <img height={24} width={24} alt="InstallPWA" src={icon} />
      <div
        className="link"
        onClick={() => openModal()}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            openModal();
          }
        }}
        tabIndex={0}
      >
        {t.installpwa}
      </div>
    </div>,

    modalIsOpen && (
      <div className="dialog-content fullscreen-overlay" key="install-modal">
        <div className="fullscreen-container" tabIndex={-1}>
          <button className={`fullscreen-close`} onClick={closeModal}>
            <img src={backIcon} width={42} height={42} alt="Close icon" />
            {t.close}
          </button>

          <div className="card-wrapper">
            <div className="card">
              <h3>{t.installheader}</h3>
              <div>{t.installios}</div>
              <ol className="pt-65 list">
                <li className="list-item">{t.install.ios1}</li>
                <li className="list-item">{t.install.ios2}</li>
                <li className="list-item">{t.install.ios3}</li>
                <li className="list-item last-item">{t.install.ios4}</li>
              </ol>

              <div>{t.installandroid}</div>
              <ol className="pt-65 list">
                <li className="list-item">{t.install.android1}</li>
                <li className="list-item">{t.install.ios2}</li>
                <li className="list-item last-item">{t.install.ios4}</li>
              </ol>
            </div>
          </div>

          <div className="btn-group-wrapper">
            <div className="btn-group">
              <button
                className="btn btn-secondary w-100"
                onClick={() => closeModal()}
              >
                {t.close}
              </button>
            </div>
          </div>
        </div>
      </div>
    ),
  ];
};

export default InstallPWA;
